// mindzera-frontend/src/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

/* ─────────────────────────────────────────────────────────── *
   One axios instance for the whole app
 * ─────────────────────────────────────────────────────────── */
const apiRoot = import.meta.env.VITE_API_URL || 'https://mindzera.com/api';

export const api = axios.create({
  baseURL: apiRoot,
  withCredentials: false,
});

/* Attach JWT automatically */
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('mz_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function AuthProvider({ children }) {
  const [user,    setUser]  = useState(null);
  const [loading, setLoad]  = useState(true);

  /* Restore session on hard-refresh */
  useEffect(() => {
    const raw = localStorage.getItem('mz_user');
    if (raw) setUser(JSON.parse(raw));
    setLoad(false);
  }, []);

  /* ---------------- Public helpers ---------------- */
  const login = async (email, password) => {
    const { data } = await api.post('/login', { email, password });
    setUser(data.user);
    localStorage.setItem('mz_user',  JSON.stringify(data.user));
    localStorage.setItem('mz_token', data.token);
    return data.user;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('mz_user');
    localStorage.removeItem('mz_token');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, api }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
